import { upperCase as up } from '@/utils'

export default {
  'en-US': {
    name: 'English (US)',
    continent: 'America',

    // Text.
    noMatch: 'No matching data',
    notFound: 'Not Found',
    loading: 'Loading',
    viewMore: 'View More',
    auth: 'Authentication',
    project: 'Welcome to %{msg} - Project',
    live: 'Live',

    // Input field name.
    email: 'Email Address',
    username: 'Username',
    password: 'Password',
    logged: 'Keep me logged in',
    enabled: 'Enabled',
    disabled: 'Disabled',
    labelName: 'Label Name',
    displayName: 'Display Name',
    search: 'Search',
    status: 'Status',
    active: 'Active',
    right: 'Rules level',

    dashboard: 'Dashboard',
    stream: 'Live Stream',
    users: 'Users Permission',
    cog: 'System Configuration',
    profile: 'My Profile',

    account: 'Account | Accounts',
    permission: 'Permission | Permissions',
    view: 'View | Views',

    camera: 'Camera | Cameras',
    business: 'Business | Businesses',
    city: 'City | Cities',
    branch: 'Branch | Branches',
    area: 'Area | Areas',

    updated: 'Last update',
    logined: 'Last login',
    registered: 'Registered',

    button: {
      signin: 'Signin',
      signout: 'Signout',
      submit: 'Submit',
      save: 'Save Change',
      apply: 'Apply',
      confirm: 'Confirm',
      cancel: 'Cancel',
      clear: 'Clear',
      back: 'Back',
      reset: 'Reset',
      enable: 'Enable',
      on: 'ON',
      off: 'OFF',
      edit: 'Edit',
      modify: 'Modify',
      remove: 'Remove',
      copy: 'Copy',
      download: 'download'
    },

    // Errors messages.
    errors: {
      _default  : (field: any) => `The ${up(field)} value is not valid.`,
      alpha     : (field: any) => `The ${up(field)} field may only contain alphabetic characters.`,
      alpha_num : (field: any) => `The ${up(field)} field may only contain alpha-numeric characters.`,
      confirmed : (field: any) => `The ${up(field)} confirmation does not match.`,
      email     : (field: any) => `The ${up(field)} field must be a valid email.`,
      max       : (field: any, [length]: any) => `The ${up(field)} field may not be greater than ${length} characters.`,
      min       : (field: any, [length]: any) => `The ${up(field)} field must be at least ${length} characters.`,
      required  : (field: any) => `The ${up(field)} field is required.`
    }
  }
}